export const userRoles = {
  Admin: 0,
  ClientManager: 1,
  Client: 2,
  Api: 3,
  DescriptionManager: 4,
  CustomsEntryRegistrationsManager: 5,
  WarehouseManager: 6,
  Logist: 7,
  BaseErp: 8,
};
